'use strict';

require('./index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/locale-provider/style/index.tsx
 ** module id = 610
 ** module chunks = 0
 **/